import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import FormTextField from "app/components/form-components/FormTextField";
import FormAutocomplete from "app/components/form-components/FormAutocomplete";
import { JobTitleRegex } from "app/utils/global_constants";
import useAuth from "app/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { getCompanyNames } from "app/api/company_api";
import { useLocation } from "react-router-dom";
function AddTitleAndCompany({ control, preloadedData, filterOptions }) {
  const { user } = useAuth();
  const location = useLocation();
  const isAdminRole = user.role === "SA";

  const isEditPath = location.pathname.includes("/jobs/listings") ? true : false;
  //Get list of companies
  const { data: companies } = useQuery({
    queryKey: ["company_name_list"],
    queryFn: () => getCompanyNames(0),
    staleTime: Infinity
  });

  const companyOptions = useMemo(() => {
    if (!companies) return [];
    return companies.map((company) => ({
      id: company.jp_id,
      label: company.jp_company_name
    }));
  }, [companies]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={isAdminRole ? 4 : 6}>
        <h3>Job Title</h3>
        <FormTextField
          control={control}
          name={"jp_title"}
          defaultValue={preloadedData ? preloadedData.jp_title : ""}
          label={"Job Title *"}
          fullWidth
          rules={{
            pattern: { value: JobTitleRegex, message: "Please enter valid job title" }
          }}
          helperText={"Title is required"}
        />
      </Grid>
      <Grid item xs={12} md={isAdminRole ? 4 : 6}>
        <h3>Number of Openings</h3>
        <FormTextField
          control={control}
          name="jp_openings_count"
          label="Number of Openings *"
          type="number"
          defaultValue={preloadedData ? preloadedData.jp_openings_count : ""}
          helperText="Number of openings is required"
          inputProps={{ min: 1 }}
          fullWidth
        />
      </Grid>
      {/** For Admin role when posting a job we need to show company dropdown */}
      {/** But when updating job details, we disable company dropdown  */}
      {isAdminRole && companies && (
        <Grid item xs={12} md={4}>
          <FormAutocomplete
            control={control}
            name={"jp_company_name"}
            label={"Company *"}
            defaultValue={preloadedData?.company.jp_company_name}
            values={companyOptions}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            filterOptions={filterOptions}
            disabled={isEditPath ? true : false}
            helperText={"Company name is required"}
            sxValues={{ width: "100%", mb: 0 }}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default AddTitleAndCompany;
